module.exports = __webpack_public_path__ + "img/1.f37da7f3.png";